import 'babel-polyfill';
import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import App from './App.vue';
import router from './router';
import store from './store';
// import './registerServiceWorker';
import vuetify from './plugins/vuetify';
import configApp from './config/system';
// import VueGtm from 'vue-gtm';
// import VueGtag from "vue-gtag";
// import VueFacebookPixel from 'vue-analytics-facebook-pixel';
// import auth from './plugins/auth';

Vue.config.productionTip = false;


new Vue({
  router,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app');

Vue.use(VueAxios, axios);

/*
Vue.use(VueGtm, {
  id: configApp.GOOGLE_TAG_MANAGER_CODE,
  enabled: true,
  debug: false,
  loadScript: true,
  vueRouter: router,
});

Vue.use(VueGtag, {
  config: { id: configApp.GOOGLE_ANALYTICS_CODE },
});

Vue.use(VueFacebookPixel);
*/

Vue.axios.defaults.baseURL = configApp.apiUrl;
